import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "layout-wrapper" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "footer-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_error = _resolveComponent("error")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_n_layout_content = _resolveComponent("n-layout-content")!
  const _component_som_footer = _resolveComponent("som-footer")!
  const _component_n_layout = _resolveComponent("n-layout")!
  const _component_ToastProvider = _resolveComponent("ToastProvider")!
  const _component_n_dialog_provider = _resolveComponent("n-dialog-provider")!
  const _component_n_loading_bar_provider = _resolveComponent("n-loading-bar-provider")!
  const _component_n_config_provider = _resolveComponent("n-config-provider")!

  return (_openBlock(), _createBlock(_component_n_config_provider, { "theme-overrides": _ctx.themeOverrides }, {
    default: _withCtx(() => [
      _createVNode(_component_n_loading_bar_provider, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_dialog_provider, null, {
            default: _withCtx(() => [
              _createVNode(_component_ToastProvider, null, {
                default: _withCtx(() => [
                  _createVNode(_component_n_layout, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_Header),
                        _createVNode(_component_n_layout_content, null, {
                          default: _withCtx(() => [
                            _createElementVNode("main", _hoisted_2, [
                              _createVNode(_component_error),
                              _createVNode(_component_router_view)
                            ])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_som_footer)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["theme-overrides"]))
}